import { CheckCircleOutlined, EditOutlined, MailOutlined, StopOutlined, LinkOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import MandarCorreoPreCotizacion from "./MandarCorreoPreCotizacion/MandarCorreoPreCotizacion";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class PreCotizacionIngenieria extends Component {
  tableRef = null;
  state = {
    todasPreCotizaciones: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    textoFiltro: "",
    modalCorreoVisible: false,
    modalCorreoId: null,
  };

  consultarPreCotizaciones(params) {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/selectPreCotizaciones",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todasPreCotizaciones: [] });
        } else {
          this.setState({
            todasPreCotizaciones: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  cambiarEstado(preCotizacionId, estado) {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/cambiarEstadoPreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId, estado },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(estado === 1 ? "Pre Cotización habilitada" : "Pre Cotización deshabilitada");
        } else {
          message.error("Sucedió un error y no se pudo actualizar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
      });
  }

  agregarPreCotizacion() {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria");
  }

  verPreCotizacion(id) {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria", { id, modo: "ver" });
  }

  editarPreCotizacion(id) {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria", { id, modo: "editar" });
  }

  verCotizacionLigada(cotizacionId) {
    this.props.history.push("/panel/verCotizacion", { id: cotizacionId });
  }

  abrirCorreo(id) {
    this.setState({ modalCorreoVisible: true, modalCorreoId: id });
  }

  cerrarCorreo() {
    this.setState({ modalCorreoVisible: false, modalCorreoId: null });
  }

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "8%",
      },
      {
        title: "Nombre de la cotización",
        dataIndex: "nombreProyecto",
        key: "nombreProyecto",
        buscar: "nombreProyecto",
        width: "18%",
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        width: "14%",
      },
      {
        title: "Encargado",
        dataIndex: "encargado",
        key: "encargado",
        width: "12%",
      },
      {
        title: "Urgente",
        dataIndex: "urgente",
        key: "urgente",
        width: "8%",
        render: (value) => (value ? <Tag color="red">Sí</Tag> : <Tag>No</Tag>),
      },
      {
        title: "Fecha Compromiso",
        dataIndex: "fechaCompromiso",
        key: "fechaCompromiso",
        width: "10%",
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "—"),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Cotización",
        dataIndex: "cotizacionId",
        key: "cotizacionId",
        width: "8%",
        render: (value) =>
          value ? (
            <Tooltip
              title="Ver Cotización"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                type="default"
                size="small"
                lila
                icon={<LinkOutlined />}
                onClick={() => this.verCotizacionLigada(value)}
              />
            </Tooltip>
          ) : (
            "—"
          ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "12%",
        render: (value, record) => {
          if (record.version !== 2) return <Tag>Formato anterior</Tag>;
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`tooltip-correo-${record._id}`}
              title="Mandar Correo"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`correo-${record._id}`}
                type="default"
                size="small"
                blanco
                icon={<MailOutlined />}
                onClick={() => this.abrirCorreo(record._id)}
              />
            </Tooltip>
          );

          buttons.push(
            <Tooltip
              key={`tooltip-editar-${record._id}`}
              title="Editar Pre Cotización"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarPreCotizacion(record._id)}
              />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar esta pre cotización?"
                onConfirm={() => this.cambiarEstado(record._id, 2)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar esta pre cotización?"
                onConfirm={() => this.cambiarEstado(record._id, 1)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Pre Cotización"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activo", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem type="primary" olivo className="botonAgregar" key="agregarPreCotizacion" onClick={this.agregarPreCotizacion.bind(this)} icon={<PlusOutlined />}>
                Agregar
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarPreCotizaciones.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          dataSource={this.state.todasPreCotizaciones}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"preCotizacionIngenieria" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (record.version === 2) this.verPreCotizacion(record._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorDefault={1}
        />
        <MandarCorreoPreCotizacion
          visible={this.state.modalCorreoVisible}
          id={this.state.modalCorreoId}
          onCerrar={this.cerrarCorreo.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(PreCotizacionIngenieria);
